module.exports = __webpack_public_path__ + "img/udarw.7141ab7a.svg";